module.exports = __webpack_public_path__ + "img/title_bg_weisheng_420.36d3efc3.png";